// extracted by mini-css-extract-plugin
export default {"center":"style_center__Cu09U"};